module.exports = __webpack_public_path__ + "static/media/Mr._Mime_gaussian2.ea8ea3cf.png";